import React from "react";
import LegalLayout from "../components/legal/LegalLayout";
import PlainTextDocument from "../components/legal/PlainTextDocument";
import termsAndConditions from "../content/termsAndConditions";

const TermsOfService = () => (
  <LegalLayout title="Terms and Conditions" testId="terms-content">
    <PlainTextDocument text={termsAndConditions} />
  </LegalLayout>
);

export default TermsOfService;
